// Module
var code = `<h2 class="section-header section-header--upper-margin">Collaterals</h2>
<div class="report-filters filters" ng-if="\$ctrl.editMode">
  <div class="labelled-field">
    <label for="collateral-to-add">Collateral</label>
    <select id="collateral-to-add"
            ng-model="\$ctrl.selectedCollateralId"
            ng-options="c.id as c.name for c in \$ctrl.getApplicableCollaterals()">
    </select>
  </div>
  <div class="labelled-field">
    <button class="btn btn-primary"
            ng-disabled="!\$ctrl.selectedCollateralId"
            ng-click="\$ctrl.addCollateral()">
      Add
    </button>
  </div>
</div>
<table class="table table--generate-row-ids">
  <thead>
    <tr>
      <td>No.</td>
      <td>Name</td>
      <td>AV % applied as collateral</td>
      <td>Collaterals</td>
      <td ng-if="\$ctrl.loanSecurityType === 'HOD'">Hold out product number</td>
      <td ng-if="\$ctrl.loanSecurityType === 'HOD'">Hold out date</td>
      <td ng-if="\$ctrl.loanSecurityType === 'HOD'">Hold out amount</td>
      <td ng-if="\$ctrl.editMode">Actions</td>
    </tr>
  </thead>
    <tbody class="tbody">
      <tr ng-repeat="item in \$ctrl.loanCollaterals">
        <td></td>
        <td>{{item.name}}</td>
        <td>
          <glue-container append-percentage="true">
            <input type="number"
                   ng-model="item.percentageOfAppraisalValue"
                   ng-required="false" min="0" step="0.00001"/>
          </glue-container>
        </td>
        <td>
          <file-id-upload
            ng-model="item.fileIds"
            ng-disabled="true"
            show-remarks="false"
            enable-webcam="false">
          </file-id-upload>
        </td>
        <td ng-if="\$ctrl.loanSecurityType === 'HOD'">{{item.holdProductNumber}}</td>
        <td ng-if="\$ctrl.loanSecurityType === 'HOD'">{{item.appraisalDate}}</td>
        <td ng-if="\$ctrl.loanSecurityType === 'HOD'">{{item.appraisalValue}}</td>
        <td ng-if="\$ctrl.editMode">
          <button type="button" class="btn btn-danger"
                  ng-click="\$ctrl.removeCollateral(item)">
            Delete
          </button>
        </td>
      </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/collateral/loan-collateral.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;